import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import JSZip from 'jszip';
import moment from 'moment';

import { ModalErrorComponent, ModalErrorData } from 'app/shared/modal-error/modal-error.component';
import { Loggable } from 'app/utils/logging/loggable';

import { PhotoBoothService, PhotoBoothPicture, FramedPicture } from '../services/photo-booth.service';
import { PHOTO_BOOTH_DOWNLOAD_FAILED_TEXT, PHOTO_BOOTH_DOWNLOAD_FAILED_TITLE } from '../strings';

@Component({
  selector: 'app-photo-booth-viewer',
  templateUrl: './photo-booth-viewer.component.html',
  styleUrls: ['./photo-booth-viewer.component.scss'],
  standalone: false,
})
export class PhotoBoothViewerComponent extends Loggable implements OnInit {
  public photos: PhotoBoothPicture[] = [];
  public socialName = '';
  public selectedToShare = 0;
  public isLoading = false;
  public loadingText = '';

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: PhotoViewerData,
    public dialogRef: MatDialogRef<PhotoBoothViewerComponent>,
    private dialog: MatDialog,
    private photoBoothService: PhotoBoothService,
  ) {
    super();
    this.setDisplayName('PhotoBoothViewerComponent');
  }

  public ngOnInit(): void {
    this.photos = this.data.photoBoothPictures;
  }

  public async onDownloadButtonClick(): Promise<void> {
    this.logUserAction('onDownloadButtonClick', 'click');
    this.isLoading = true;
    this.loadingText = 'Preparing your pictures...';
    const finalImages = await this.photoBoothService.addPreciateFrame(
      this.photos,
      moment().format('MM.DD.YYYY'),
      this.socialName,
    );
    const zip = new JSZip();
    finalImages.forEach((image, index) => {
      const buffer = this.base64ToBuffer(image.base64);
      const extension = image.type.split('/')[1];
      zip.file(`group_photo_${index}.${extension}`, buffer);
    });

    let url: string | undefined;
    try {
      const content = await zip.generateAsync({ type: 'blob' });

      url = URL.createObjectURL(content);
      this.isLoading = false;
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.download = this.socialName;
      a.click();
    } catch (e) {
      this.error('Error while downloading the pictures', e);
      this.isLoading = false;
      this.dialog.open<ModalErrorComponent, ModalErrorData>(ModalErrorComponent, {
        data: {
          title: PHOTO_BOOTH_DOWNLOAD_FAILED_TITLE,
          text: PHOTO_BOOTH_DOWNLOAD_FAILED_TEXT,
        },
      });
    } finally {
      if (url) {
        URL.revokeObjectURL(url);
      }
    }
  }

  // TODO: Revisit the logic about social media integration
  // public onShareClick(): void {
  //   this.logUserAction('onShareClick', 'click');
  //   const isGIFSelected = this.selectedToShare === this.photos.length - 1; // GIF is always going to be the last pic on the array
  // }

  private base64ToBuffer(base64: string): ArrayBuffer {
    const decoded = window.atob(base64); // creates a ASCII string
    const buffer = new ArrayBuffer(decoded.length),
      view = new Uint8Array(buffer);
    for (let i = 0; i < decoded.length; i++) {
      view[i] = decoded.charCodeAt(i);
    }
    return buffer;
  }
}

export interface PhotoViewerData {
  photoBoothPictures: PhotoBoothPicture[];
  framedPictures: FramedPicture[];
}
